// extracted by mini-css-extract-plugin
export var checkbox = "_86-0";
export var circle = "_86-3";
export var horizontalContainer = "_86-7";
export var sm = "_86-5";
export var switch0 = "_86-2";
export var switchDisabled = "_86-8";
export var switchEnabled = "_86-1";
export var textSwitchContainer = "_86-9";
export var textSwitchOption = "_86-a";
export var textSwitchOptionSelected = "_86-b";
export var verticalContainer = "_86-6";
export var xs = "_86-4";